import ProTextInput from "../../../../Components/Inputs/TextField";
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";

const ProjectSiteModuleInfoSection = ({
  defaultFormProps,
  formConfig,
  permissions,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    { key: "moduleSelected" },
    { key: "moduleType" },
    { key: "modulQuantity" },
    { key: "stringSizes" },
  ];

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible defaultClose title="Project Site: Module Info">
        {fields.map(({ key }) => {
          const config = formConfig[key];
          return (
            <ProTextInput
              key={key}
              {...defaultFormProps}
              {...config}
              permission={fieldPermission(key)}
            />
          );
        })}
      </FormSectionWrapper>
    )
  );
};

export default ProjectSiteModuleInfoSection;
